import * as React from "react";
import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export default function CircularProgressWithLabel(
  props: CircularProgressProps & { value?: number },
) {
  return (
    <Box
      className="all-center-wrapper"
      sx={{
        position: "absolute",
        zIndex: 9,
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        backgroundColor: "rgba(255,255,255,0.8)",
      }}
    >
      <CircularProgress variant={props.variant || "determinate"} {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {props.value && (
          <Typography
            variant="subtitle1"
            component="div"
            color="text.secondary"
          >{`${Math.round(props.value)}%`}</Typography>
        )}
      </Box>
    </Box>
  );
}
